export var PageAction;
(function (PageAction) {
    PageAction["LIVE_MENU_CLICK"] = "PageAction.LIVE_MENU_CLICK";
    PageAction["START_PANEL_CLICK"] = "PageAction.START_PANEL_CLICK";
    PageAction["UI_HIDE"] = "PageAction.UI_HIDE";
    PageAction["UI_SHOW"] = "PageAction.UI_SHOW";
    PageAction["CC_HIDE"] = "PageAction.CC_HIDE";
    PageAction["CC_SHOW"] = "PageAction.CC_SHOW";
    PageAction["MUTE"] = "PageAction.MUTE";
    PageAction["UNMUTE"] = "PageAction.UNMUTE";
    PageAction["PAUSE"] = "PageAction.PAUSE";
    PageAction["PLAY"] = "PageAction.PLAY";
    PageAction["INITIALIZE_PLUGINS"] = "PageAction.INITIALIZE_PLUGINS";
})(PageAction || (PageAction = {}));
